const defaultItem = {
    title: null,
    name: null,
    text: null,
    type: null,
    entity: null,
    event: null
};
export default defaultItem;
